/* eslint-disable no-param-reassign */
import React from 'react';
import { Box } from '@apia/theme';

const PrintContext = React.createContext(false);
export function usePrintContext() {
  const context = React.useContext(PrintContext);
  return context;
}

const Task = () => {
  const ref = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    const tabsRender = document.querySelector('.tabs__render') as HTMLElement;
    document.querySelector('.print__container')?.remove();
    if (tabsRender) {
      const printDiv = document.createElement('div');
      printDiv.classList.add('print__container');
      printDiv.appendChild(tabsRender.cloneNode(true));
      printDiv
        .querySelectorAll('.tabs__render__child')
        .forEach(
          (current) => ((current as HTMLElement).style.display = 'block'),
        );
      document.body.append(printDiv);
      window.print();
    }
  }, []);

  return (
    <PrintContext.Provider value>
      <Box id="Print__Execution" ref={ref} />
    </PrintContext.Provider>
  );
};

export default Task;
